import styles from './SelectList.module.scss';
import { useSelectContext } from './useSelectContext';
import clsx from 'clsx';
import React from 'react';

export const SelectListItem = (props) => {
  const { handleItemClick, currentIndex, origIndex } = useSelectContext();
  const listItemClasses = clsx(styles.selectListItem, {
    [` ${styles.itemActive}`]:
      currentIndex === props.itemIndex && !props.isSelected,
    [` ${styles.itemSelected}`]:
      origIndex === props.itemIndex || props.isSelected,

    [` ${styles.itemDisabled}`]: props.isDisabled,
    [` ${styles.outOfStock}`]: props.isOutOfStock,
  });

  return (
    <li
      style={{ display: props.placeholder && 'none' }}
      role="option"
      className={clsx(listItemClasses, props.className)}
      onClick={() => !props.isOutOfStock && handleItemClick(props.itemIndex)}
      data-value={props.id}
    >
      {props.children}
    </li>
  );
};
